import useSupportStore from "../../../store/supportStore";
import { formatDateT } from "../../../../../shared/utils/formatters";
import { formatData } from "../../../utils/supportFormatters";

const stepKey = "spLicense";

const SpLicenseMapper = {
  get: () => {
    const store = useSupportStore.getState();
    return store[stepKey] || {};
  },
  set: (data) => {
    const store = useSupportStore.getState();
    store.updateStepFields(stepKey, data);

    const details = {
      "Licensing Authority": data.LicenseAuth?.label,
      "Will Your Vehicle Continue to Be Used as the Existing Use on Your Policy?":
        data.existingUseContinued,
      ...(data.existingUseContinued === "No" && {
        "What is your new use": data.hireType?.label,
      }),
      "Have You Received Your New Taxi Badge?": data.newTaxiBadge,
    };

    const currentChanges = store.Payload.Changes;
    store.updateField("Changes", {
      ...currentChanges,
      LicensingAuthority: {
        Details: details,
        effectiveFrom: formatDateT(data.licenseEffectiveDateTime) || "",
        Requested: true,
      },
    });
  },
};

export default SpLicenseMapper;
